/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { PaginatedResponseStorefrontScanResponseDTOFromJSON, ScanInfoResponseDTOFromJSON, StorefrontScanCreateBatchDTOToJSON, StorefrontScanResponseDTOFromJSON, StorefrontScanUpdateDTOToJSON, } from '../models/index';
/**
 *
 */
export class StorefrontScanControllerApi extends runtime.BaseAPI {
    /**
     */
    async batchInsertStoreRaw(requestParameters, initOverrides) {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError('storeId', 'Required parameter "storeId" was null or undefined when calling batchInsertStore().');
        }
        if (requestParameters['region'] == null) {
            throw new runtime.RequiredError('region', 'Required parameter "region" was null or undefined when calling batchInsertStore().');
        }
        const queryParameters = {};
        if (requestParameters['storeId'] != null) {
            queryParameters['storeId'] = requestParameters['storeId'];
        }
        if (requestParameters['region'] != null) {
            queryParameters['region'] = requestParameters['region'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/batch-insert-store`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StorefrontScanResponseDTOFromJSON));
    }
    /**
     */
    async batchInsertStore(requestParameters, initOverrides) {
        const response = await this.batchInsertStoreRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async batchLastScanDatesRaw(requestParameters, initOverrides) {
        if (requestParameters['storeId'] == null) {
            throw new runtime.RequiredError('storeId', 'Required parameter "storeId" was null or undefined when calling batchLastScanDates().');
        }
        if (requestParameters['region'] == null) {
            throw new runtime.RequiredError('region', 'Required parameter "region" was null or undefined when calling batchLastScanDates().');
        }
        const queryParameters = {};
        if (requestParameters['storeId'] != null) {
            queryParameters['storeId'] = requestParameters['storeId'];
        }
        if (requestParameters['region'] != null) {
            queryParameters['region'] = requestParameters['region'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/batch-last-scan`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScanInfoResponseDTOFromJSON));
    }
    /**
     */
    async batchLastScanDates(requestParameters, initOverrides) {
        const response = await this.batchLastScanDatesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createStorefrontScanRaw(requestParameters, initOverrides) {
        if (requestParameters['storefrontScanCreateBatchDTO'] == null) {
            throw new runtime.RequiredError('storefrontScanCreateBatchDTO', 'Required parameter "storefrontScanCreateBatchDTO" was null or undefined when calling createStorefrontScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StorefrontScanCreateBatchDTOToJSON(requestParameters['storefrontScanCreateBatchDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StorefrontScanResponseDTOFromJSON));
    }
    /**
     */
    async createStorefrontScan(requestParameters, initOverrides) {
        const response = await this.createStorefrontScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteStorefrontScanRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteStorefrontScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteStorefrontScan(requestParameters, initOverrides) {
        await this.deleteStorefrontScanRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteStorefrontScansRaw(requestParameters, initOverrides) {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError('ids', 'Required parameter "ids" was null or undefined when calling deleteStorefrontScans().');
        }
        const queryParameters = {};
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/batchDelete`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteStorefrontScans(requestParameters, initOverrides) {
        await this.deleteStorefrontScansRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getLastScanDatesRaw(requestParameters, initOverrides) {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling getLastScanDates().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/last-scan`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScanInfoResponseDTOFromJSON));
    }
    /**
     */
    async getLastScanDates(requestParameters, initOverrides) {
        const response = await this.getLastScanDatesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getStorefrontScanRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getStorefrontScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => StorefrontScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getStorefrontScan(requestParameters, initOverrides) {
        const response = await this.getStorefrontScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getStorefrontScansRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['statusList'] != null) {
            queryParameters['statusList'] = requestParameters['statusList'];
        }
        if (requestParameters['tag'] != null) {
            queryParameters['tag'] = requestParameters['tag'];
        }
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        if (requestParameters['shopName'] != null) {
            queryParameters['shopName'] = requestParameters['shopName'];
        }
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = requestParameters['startDateFrom'].toISOString();
        }
        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = requestParameters['startDateTo'].toISOString();
        }
        if (requestParameters['endDateFrom'] != null) {
            queryParameters['endDateFrom'] = requestParameters['endDateFrom'].toISOString();
        }
        if (requestParameters['endDateTo'] != null) {
            queryParameters['endDateTo'] = requestParameters['endDateTo'].toISOString();
        }
        if (requestParameters['createdBy'] != null) {
            queryParameters['createdBy'] = requestParameters['createdBy'];
        }
        if (requestParameters['createdByNotInList'] != null) {
            queryParameters['createdByNotInList'] = requestParameters['createdByNotInList'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseStorefrontScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getStorefrontScans(requestParameters = {}, initOverrides) {
        const response = await this.getStorefrontScansRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async markStorefrontScanAsExportedRaw(requestParameters, initOverrides) {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError('ids', 'Required parameter "ids" was null or undefined when calling markStorefrontScanAsExported().');
        }
        const queryParameters = {};
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/markExported`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async markStorefrontScanAsExported(requestParameters, initOverrides) {
        const response = await this.markStorefrontScanAsExportedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async partialUpdateStorefrontScanRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling partialUpdateStorefrontScan().');
        }
        if (requestParameters['storefrontScanUpdateDTO'] == null) {
            throw new runtime.RequiredError('storefrontScanUpdateDTO', 'Required parameter "storefrontScanUpdateDTO" was null or undefined when calling partialUpdateStorefrontScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StorefrontScanUpdateDTOToJSON(requestParameters['storefrontScanUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => StorefrontScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async partialUpdateStorefrontScan(requestParameters, initOverrides) {
        const response = await this.partialUpdateStorefrontScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async restartStorefrontScanRaw(requestParameters, initOverrides) {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError('ids', 'Required parameter "ids" was null or undefined when calling restartStorefrontScan().');
        }
        const queryParameters = {};
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/storefront-scan/restartSearch`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async restartStorefrontScan(requestParameters, initOverrides) {
        const response = await this.restartStorefrontScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetStorefrontScansStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * @export
 */
export const GetStorefrontScansStatusListEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * @export
 */
export const GetStorefrontScansTagEnum = {
    Control: 'CONTROL',
    Closed: 'CLOSED',
    Forbidden: 'FORBIDDEN'
};
/**
 * @export
 */
export const GetStorefrontScansTypeEnum = {
    Store: 'STORE',
    Category: 'CATEGORY'
};
/**
 * @export
 */
export const GetStorefrontScansLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
